<template>
<div class="row full-width-header patient-accountability">
  <div class="col">
    <v-header :title="title" :isNewAccountability="isNewAccountability" :accountabilityId="accountabilityId" v-if="accountabilityId"></v-header>
    <div class="row grid-padding" id="step1">
      <div class="col-xs-12 col-md-12 accountability-column col-lg-6" id="step2">
        <div class="accountability-column-questions" name="card-animation">
          <fieldset v-for="(question, indexquestion) in questions" :key="indexquestion" :data-index="indexquestion">
            <legend v-if="question.QuestionId != '1000'">{{question.Tekst}}</legend>
            <p v-if="question.Opmerking.length">{{question.Opmerking}}</p>
            <div v-for="(answer, index) in question.Antwoorden" :key="index" :data-index="index">
              <!--STANDARD (RADIO) QUESTION-->
              <div class="form-group__radio" v-if="answer.TypeCode === 'Standard'">
                <input :id="answer.AnswerId" :checked="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId" @change="checkRadioAnswer($event, question.AccountabilityLineId)" :name="question.AccountabilityLineId" type="radio" />
                <label :for="answer.AnswerId"><span><span></span></span>{{answer.AntwoordTekst}}</label>
              </div>
              <!--STANDARD (RADIO) QUESTION WITH OPEN (TextInput) -->
              <div v-if="answer.TypeCode === 'OpenStandaard'">
                <div class="form-group__radio" >
                  <input :id="answer.AnswerId" :checked="checkRadioStatus(question.ResultaatAnswers, answer.AnswerId, question.AccountabilityLineId)" @change="checkedRadioAnswerStandard(answer.AnswerId, question.AccountabilityLineId)" :name="question.AccountabilityLineId" type="radio" />
                  <label :for="answer.AnswerId"><span><span></span></span>{{answer.AntwoordTekst}}</label>
                </div>
                <form @submit="submitTypeQuestionOpen" class="openquestion" :id="'form' + answer.AnswerId" style="display: none" :name="question.AccountabilityLineId">
                  <div class="row grid-padding">
                    <div class="col-xs-12 col-md-8">
                      <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                        <v-input-group-simple @input="input" type="text" v-on:input="changeRadioText($event, question.ResultaatAnswers[0].Resultaat, question.AccountabilityLineId)" :inputid="answer.AnswerId + 'txt'" :initvalue="question.ResultaatAnswers[0].Resultaat " sm alt></v-input-group-simple>
                      </div>
                      <div v-else>
                        <v-input-group-simple @input="input" type="text" :inputid="answer.AnswerId + 'txt'" sm alt></v-input-group-simple>
                      </div>
                    </div>
                    <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                      <div v-if="currentRadioAnswerId === answer.AnswerId && isRadioTextChanged === true">
                        <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextRadioButtonStatus(answer.AnswerId)">Opslaan</v-button>
                      </div>
                      <div v-else>
                        <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow>Opgeslagen</v-button>
                      </div>
                    </div>
                    <div v-else>
                      <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextRadioButtonStatus(answer.AnswerId)">Opslaan</v-button>
                    </div>
                  </div>
                  <div class="row grid-padding" v-if="alertVisibityStatus(question.ResultaatAnswers, answer.AnswerId)">
                      <div class="details" :id="'div' + question.AccountabilityLineId">
                        <div class="error">Het is verplicht dit veld in te vullen en op de knop 'Opslaan' te klikken.</div>
                      </div>
                  </div>
                </form>
              </div>
              <!--DROPDOWN QUESTION -->
              <v-select-group v-if="answer.TypeCode === 'Dropdown'"
              label="Maak een keuze"
              :selectid="question.AccountabilityLineId.toString()"
              :data-answerid="answer.AnswerId"
              :initselected="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerListItemId"
              @change="checkSelectAnswer"
              >
                <option v-for="(option, indexoptions) in answer.AntwoordLijst" :key="indexoptions" :data-index="indexoptions" :initvalue="option.AnswerListItemId" :value="option.AnswerListItemId" :data-answerid="answer.AnswerId">{{option.Omschrijving}}</option>
              </v-select-group>
              <!--OPEN (TextInput) QUESTION -->
              <form @submit="submitTypeQuestionOpen" v-if="answer.TypeCode === 'Open'" :name="question.AccountabilityLineId">
                <div class="row">
                  <div class="col-xs-12 col-md-8">
                    <div v-if="question.ResultaatAnswers.length > 0">
                      <v-input-group-simple @input="input" type="text" :inputid="answer.AnswerId" :initvalue="question.ResultaatAnswers[0].Resultaat" sm alt></v-input-group-simple>
                    </div>
                    <div v-else>
                      <v-input-group-simple @input="input" type="text" :inputid="answer.AnswerId" sm alt></v-input-group-simple>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-4">
                    <v-button type="submit" :id="answer.AnswerId + 'btn'" lg hollow :disabled="getNextButtonStatus(answer.AnswerId)">Opslaan</v-button>
                  </div>
                </div>
              </form>
              <!--CHECKBOX QUESTION -->
              <form @submit="submitCheckbox($event, answer.AnswerId)" v-if="answer.TypeCode === 'Checkbox'" :name="question.AccountabilityLineId">
                <div class="row grid-margin">
                  <div class="col-xs-12">
                    <v-checkbox-group
                      v-for="(checkbox, index) in answer.AntwoordLijst"
                      :key="index"
                      :label="checkbox.Omschrijving"
                      :inputid="checkbox.AnswerListItemId"
                      :initvalue="getCheckboxStatus(question.ResultaatAnswers, checkbox.AnswerListItemId)"
                      :overwriteValue="checkbox.IsOpen"
                      :name="answer.AnswerId"
                      >
                    </v-checkbox-group>
                  </div>
                  <div class="col-xs-12 remark checkbox-msg" :id="'remark-' + question.AccountabilityLineId" >*Selecteer ten minste één antwoord.</div>
                  <div class="col-xs-4">
                    <v-button type="submit" lg hollow >Volgende vraag</v-button>
                  </div>
                </div>
              </form>
              <div class="remark" v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId && answer.Opmerking" v-html="answer.Opmerking"></div>
            </div>
          </fieldset>
          <!--Start DATE QUESTION-->
          <div class="row customStartDate form-group__date" v-if="showStartDate()">
            <div class="col-xs-12 col-md-8">
              <v-input-date-picker
                ref="startDate"
                type="date"
                name="startDate"
                label="Startdatum therapie:"
                autofocus
                @selected="handleStartDate"
              >
              </v-input-date-picker>
            </div>
            <div>
              <v-button lg cta class="customStartDateSubmit" @click.native.prevent="customStartDateSubmit">Afronden</v-button>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div v-if="showSuccessMessage()" class="complete">
            <svg class="checked" style="width:38px;height:38px" viewBox="0 0 24 24">
              <path fill="#fff" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
            </svg>
            {{accountabilityTexts.AccountabilityCompletionText}}
          </div>
          <div class="complete notpossible" v-if="isLastAnswer && !isAllowedToProceed">
            {{accountabilityTexts.AccountabilityNonCompletionText}}
          </div>
        </transition>
      </div>
      <div class="col-xs-12 col-md-12 product-column col-lg-6">
        <v-select-product v-if="!isSingleAccountability && productSelectionAccountabilityId" :accountabilityTexts="accountabilityTexts" v-bind:accountabilityId="accountabilityId" v-bind:productSelectionAccountabilityId="productSelectionAccountabilityId"></v-select-product>
        <div class="row grid-margin grid-justify-content-right" v-if="isSingleAccountability">
          <div class="col-xs-12 col-sm-3">
            <v-button hollow lg @click.native.prevent="cancelAccountability" >Annuleren</v-button>
          </div>
          <div class="col-xs-12 col-sm-5">
            <v-button cta lg :class="{'greyOut': !isLastAnswer}" @click.native.prevent="signin"> Controleren & Ondertekenen</v-button>
          </div>
        </div>
      </div>
    </div>
    <!--Pop up to show validation messages -->
    <generic-modal v-if="showValidationPopUp">
      <template #header>
        {{accountabilityTexts.AccountabilityValidationMessageTitle}}
      </template>
      <template #body>
        <p>{{accountabilityTexts.AccountabilityValidationMessageText}}</p>
      </template>
      <template #footer>
        <v-button tagelement="button" md primary @click.native.prevent="closeModal">Ga verder</v-button>
      </template>
    </generic-modal>
  </div>
</div>
</template>
<script>
  import $ from 'jquery'
  import store from '@/store'
  import router from '@/router'
  import { mapGetters } from 'vuex'
  import GenericModal from '@/components/shared/GenericModal'
  import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
  import VSelectProduct from '@/components/sections/patient/accountability/selectProduct/Index'
  import VButton from '@/components/shared/Button.vue'
  import VHeader from '@/components/sections/patient/accountability/PatientAccountabilityHeader'
  import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker'
  import 'intro.js/minified/introjs.min.css'
  import introJs from 'intro.js'
  import {
    getAccountabilityRootStatus
  } from '@/services';
  import { router$ } from '@/router/router$';
  import { tap, map, filter, switchMap } from 'rxjs/operators';

  export default {
    name: 'PatientAccountability',
    components: {
      VButton,
      VHeader,
      VCheckboxGroup,
      VSelectProduct,
      VInputDatePicker,
      GenericModal
    },
    subscriptions () {
      var accountabilityId$ = router$.pipe(
          map(route => route && route.params.id / 1),
          filter(accountabilityId => !!accountabilityId)
        );
      return {
        accountabilityId: accountabilityId$.pipe(
          tap(accountabilityId => this.loadAccountability(accountabilityId))
        ),
        productSelectionAccountabilityId: accountabilityId$.pipe(
          switchMap(accountabilityId => getAccountabilityRootStatus(accountabilityId)),
          map(accountabilityRootStatus => accountabilityRootStatus.productSelection.accountabilityId)
        )
      };
    },
    data () {
      return {
        startDate: null,
        isStartDateAnswered: false,
        showValidationPopUp: false,
        intro: introJs(),
        currentRadioAnswerId: 0,
        isRadioTextChanged: false
      }
    },
    computed: {
      ...mapGetters({
        patientGegevens: 'patient/getPatientGegevens',
        questions: 'accountability/getQuestions',
        isLastAnswer: 'accountability/getIsLastAnswer',
        isAllowedToProceed: 'accountability/getIsAllowedToProceed',
        isSingleAccountability: 'accountability/getIsSingleAccountability',
        isNewAccountability: 'accountability/getIsNewAccountability',
        title: 'accountability/getTitleAccountability',
        isStartDate: 'accountability/getIsStartDate',
        accountabilityTexts: 'accountability/getAccountabilityTexts',
        productsSelected: 'selectProduct/getProductsSelected'
      })
    },
    async created () {
      await store.dispatch('patient/getCurrentPatient')

      if (store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicenseTwoColumn) {
        setTimeout(() => {
          const self = this
          this.intro.setOptions({
            steps: [
              {element: '#step1', intro: 'Een machtiging bestaat uit het invullen van de verantwoording ( links ) en het selecteren van producten ( rechts ). Je mag zelf bepalen wat je eerst wil doen, maar beide moeten wel compleet worden ingevuld voordat je verder kan. Zullen we beginnen? Druk dan op Volgende.', position: 'right'},
              {element: '#step2', intro: 'We beginnen bij het invullen van de verantwoording. Vul de vragenlijst volledig in tot dat je de melding krijgt: De machtiging is afgerond. Klik op volgende om door te gaan.', position: 'right'},
              {element: '#search', intro: 'Lekker bezig! We zijn al halverwege. Nu de productselectie. Je kan producten op verschillende manieren zoeken. Ten eerste heb je een zoekfunctie.', position: 'right'},
              {element: '#step4', intro: 'Je kan ook producten selecteren door met de dropdowns de juiste categorie te vinden.', position: 'right'},
              {element: '#step5', intro: 'Probeer nu zelf maar eens wat producten toe te voegen. Als je klaar bent druk je op volgende.', position: 'right'},
              {element: '#step7', intro: 'Ben je klaar met de product selectie klik dan op de button Controleren & Ondertekenen.', position: 'right'}
            ],
            exitOnEsc: false,
            exitOnOverlayClick: false,
            skipLabel: 'Overslaan',
            nextLabel: 'Volgende >',
            prevLabel: '< Terug',
            doneLabel: 'Okey, begrepen'
          })
          this.intro.start().oncomplete(function () {
            self.intro.exit()
          })
          window.scrollTo(0, 0)
        }, 1500)
      }
    },
    watch: {
      isLastAnswer (value) {
        if (value) {
          // scroll to top of the page is the last answer got submitted
          if (!this.isStartDate) {
            this.scrollToTop()
          }
        }
      },
      'productsSelected.length' (value) {
        if (value === 1 && store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicenseTwoColumn) {
          const self = this
          this.intro.exit()
          setTimeout(() => {
            this.intro.setOptions({
              steps: [
                {element: '#step1', intro: 'Een machtiging bestaat uit het invullen van de verantwoording ( links ) en het selecteren van producten ( rechts ). Je mag zelf bepalen wat je eerst wil doen, maar beide moeten wel compleet worden ingevuld voordat je verder kan. Zullen we beginnen? Druk dan op Volgende.', position: 'right'},
                {element: '#step2', intro: 'We beginnen bij het invullen van de verantwoording. Vul de vragenlijst volledig in tot dat je de melding krijgt: De machtiging is afgerond. Klik op volgende om door te gaan.', position: 'right'},
                {element: '#search', intro: 'Lekker bezig! We zijn al halverwege. Nu de productselectie. Je kan producten op verschillende manieren zoeken. Ten eerste heb je een zoekfunctie.', position: 'right'},
                {element: '#step4', intro: 'Je kan ook producten selecteren door met de dropdowns de juiste categorie te vinden.', position: 'right'},
                {element: '#step5', intro: 'Probeer nu zelf maar eens wat producten toe te voegen. Als je klaar bent druk je op volgende.', position: 'right'},
                {element: '#step6', intro: 'Hier zie je een overzicht van alle producten die je geselecteerd hebt. Je kan ook de aantallen aanpassen en producten toevoegen aan een gecombineerde dagdosering. Als je klaar bent druk dan op volgende.', position: 'right'},
                {element: '#step7', intro: 'Ben je klaar met de product selectie klik dan op de button Controleren & Ondertekenen.', position: 'right'}
              ],
              exitOnEsc: false,
              exitOnOverlayClick: false,
              skipLabel: 'Overslaan',
              nextLabel: 'Volgende >',
              prevLabel: '< Terug',
              doneLabel: 'Okey, begrepen'
            })
            this.intro.start().goToStep(6).oncomplete(function () {
              self.intro.exit()
            })
          }, 1500)
        }
      }
    },
    methods: {
      async loadAccountability (accountabilityId) {
        await store.dispatch('accountability/getQuestions', accountabilityId);
      },
      alertVisibityStatus (resultList, ansId) {
        let status = true
        if (resultList.length > 0 && resultList[0].AnswerId === ansId) {
          status = false
        }
        return status
      },
      changeRadioText (event, result, accountabilityLineId) {
        let answerId = event
        let answerText = document.getElementById(answerId) ? document.getElementById(answerId).value.trimEnd() : ''
        this.currentRadioAnswerId = answerId.replace('txt', '')
        if (result !== answerText) {
          this.isRadioTextChanged = true
        } else {
          this.isRadioTextChanged = false
        }
      },
      checkRadioStatus (resultList, ansId, lineId) {
        let status = false
        if (resultList.length > 0 && resultList[0].AnswerId === ansId) {
          if (resultList[0].AnswerId === ansId) {
            status = true
            setTimeout(() => {
              this.checkedRadioAnswerStandard(ansId, lineId)
            }, 1000)
          }
        }
        return status
      },
      checkRadioAnswer (e, nameId) {
        let formDivId = 'form' + e.currentTarget.name
        let formDiv = document.getElementById(formDivId)
        if (formDiv) {
          formDiv.style.display = 'none'
        }
        let otherFormDivs = document.getElementsByName(nameId)
        otherFormDivs.forEach((form) => {
          if (form.localName === 'form') {
            form.style.display = 'none'
          }
        })        
        let answerObject = {
          'AccountabilityLineId': e.currentTarget.name,
          'Resultaten': [{
            'AnswerId': document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id,
            'Resultaat': ' '
          }]
        }
        this.submitAnswers(answerObject)
      },
      checkSelectAnswer (e) {
        let answerObject = {
          'AccountabilityLineId': e.currentTarget.name,
          'Resultaten': [{
            'AnswerId': e.currentTarget.options[e.currentTarget.selectedIndex].dataset.answerid,
            'Resultaat': '',
            'AnswerListItemId': e.currentTarget.options[e.currentTarget.selectedIndex].value
          }]
        }
        this.submitAnswers(answerObject)
      },
      submitTypeQuestionOpen (e) {
        e.preventDefault()
        let answerId = e.currentTarget.elements[0].id
        answerId = answerId.replace('txt', '')
        if (this.isRadioTextChanged === true) {
          this.isRadioTextChanged = false
        }
        let answerObject = {
          'AccountabilityLineId': e.currentTarget.name,
          'Resultaten': [{
            'AnswerId': answerId,
            'Resultaat': e.currentTarget.elements[0].value
          }]
        }
        this.submitAnswers(answerObject)
      },
      async submitAnswers (answerObject) {
        answerObject.ForProductSelection = false
        await store.dispatch('accountability/setAnswer', answerObject)
        await store.dispatch('accountability/getQuestions', this.accountabilityId)
        if (!this.isLastAnswer) {
          await this.scrollToBottom()
        }
      },
      cancelAccountability () {
        store.dispatch('accountability/cancelAccountabilityForm', this.accountabilityId).then(() => {
          router.push('/patientdashboard')
        })
      },
      getCheckboxStatus (resultArray, checkboxId) {
        let state = false
        for (let i = 0; i < resultArray.length; i++) {
          if (resultArray[i].AnswerListItemId === checkboxId) {
            state = true
          }
        }
        return state
      },
      submitCheckbox (e, answerId) {
        e.preventDefault()
        let result = []
        for (let i = 0; i < e.currentTarget.elements.length - 1; i++) {
          if (e.currentTarget.elements[i].value === 'true') {
            result.push({
              'AnswerListItemId': e.currentTarget.elements[i].id,
              'Resultaat': e.currentTarget.elements[i].value,
              'AnswerId': answerId
            })
          }
        }
        if (result.length > 0) {
          $('#remark-' + e.currentTarget.name).hide()
          let answerObject = {
            'AccountabilityLineId': e.currentTarget.name,
            'Resultaten': result
          }
          this.submitAnswers(answerObject)
        } else {
          $('#remark-' + e.currentTarget.name).show()
        }
      },
      getColumnClass (type) {
        if (type === 'accountability') {
          return this.isLastAnswer ? 'col-lg-4' : 'col-lg-8'
        }
        if (type === 'product') {
          return this.isLastAnswer ? 'col-lg-8' : 'col-lg-4'
        }
      },
      // Function to scroll to the bottom of the page
      async scrollToTop () {
        $('html, body').animate({scrollTop: 0}, 'slow')
      },
      input (id, value) {
        id = id.replace('txt', '')
        let btnId = '#' + id + 'btn'
        if (value && value !== '') {
          $(btnId).removeClass('btn--disabled')
        } else {
          $(btnId).addClass('btn--disabled')
        }
      },
      getNextButtonStatus (id) {
        if (id) {
          let value = $(id).val()
          return value === undefined || value === '' || value === null
        }
        return true
      },
      getNextRadioButtonStatus (id) {
        if (id) {
          let txtId = id + 'txt'
          let value = document.getElementById(txtId) ? document.getElementById(txtId).value : ''
          return value === undefined || value === '' || value === null
        }
        return true
      },
      // Function to handle accountability radio standard type question answer
      checkedRadioAnswerStandard (radioId, nameId) {
        $('.remark').hide()
        let radioButton = document.getElementById(radioId)
        let formDivId = 'form' + radioId
        let formDiv = document.getElementById(formDivId)
        let otherFormDivs = document.getElementsByName(nameId)
        otherFormDivs.forEach((form) => {
          if (form.localName === 'form') {
            form.style.display = 'none'
          }
        })
        if (radioButton) {
          formDiv.style.display = radioButton.checked ? 'block' : 'none'
        }
      },
      // Function to scroll to the bottom of the page
      async scrollToBottom () {
        $('html, body').animate({scrollTop: $('.accountability-column-questions').height()}, 'slow')
      },
      // Function to show start date input field
      showStartDate () {
        return this.isLastAnswer && this.isStartDate
      },
      // Function to handle start date value
      handleStartDate (date) {
        this.startDate = date
        store.commit('accountability/setStartDateForTwoColumnAccountability', date)
      },
      customStartDateSubmit () {
        this.isStartDateAnswered = true
        this.scrollToTop()
      },
      showSuccessMessage () {
        if (this.isStartDate) {
          return this.isLastAnswer && this.isAllowedToProceed && this.isStartDateAnswered
        }
        return this.isLastAnswer && this.isAllowedToProceed
      },
      closeModal () {
        this.showValidationPopUp = false
      },
      signin () {
        if (!this.isLastAnswer) {
          this.showValidationPopUp = true
        } else {
          router.push('/machtiging-overzicht/' + this.accountabilityId);
        }
      }
    },
    destroyed () {
      store.commit('accountability/setQuestions', {})
      store.commit('selectProduct/resetProductsAndFilters')
      store.commit('accountability/setIsAllowedToProceed', false)
      store.commit('accountability/setIsLastAnswer', false)      
    }
  }
</script>

<style lang="scss" scoped>
  .card-animation-enter-active, .card-animation-leave-active {
      transition: all 0.5s ease;
  }
  .card-animation-enter, .card-animation-leave-to {
      opacity: 0;
    transform: translateX(30px);
  }
  .productOverlay {
    position: absolute !important;
    opacity: 1;
    div {
      display: none;
    }
  }
  .customStartDateSubmit {
    margin-top: 34px;
  }
  .checkbox-msg {
    display: none;
  }
  .full-width-header{
    width:100%;
  }
  .main__view{
    padding:0;
  }
  form.openquestion{
    padding-bottom: 16px;
  }
  fieldset{
    margin:0;
    padding: 6px 0 20px;
    border:0;

    legend{
      font-weight:bold;
      line-height: 1.4;
      color: $gray-darkest;
    }
  }
  .form-group #menu-down-icon {
    fill:$aqua ;
  }
  /deep/
  .form-group label {
    color: $gray-dark;
  }
  .accountability-column,
  .product-column {
    position: relative;
    display: block;

    background-color:$teal-lighter;
    min-height: calc(100vh - 126px);
    @each $breakpoint-key, $breakpoint-value in $grid-breakpoints {
      @include min-screen(grid-breakpoint($breakpoint-key)) {
        padding-top: grid-gutter($breakpoint-key) ;
      }
    }
  }
  .accountability-column{
    padding-bottom: 100px;
  }
  .remark{
    font-size: .8rem;
    color: $red;
    padding: 0 0 1rem calc(20px + .5rem);

  }
  .product-column {
    background-color:$teal-lightest;
  }
  .complete {
    margin-left: -25px;
    background: $dark-green;
    color: $white;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    position: fixed;
   &.notpossible {
      background: $yellow;
    }
    @each $breakpoint-key, $breakpoint-value in $grid-breakpoints {
      @include min-screen(grid-breakpoint($breakpoint-key)) {
        padding: grid-gutter($breakpoint-key) - 8;
        bottom: grid-gutter($breakpoint-key) - 8;
      }
    }
   .checked{
      display: inline-block;
      margin-right:10px
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s ease-out, bottom 0.25s ease-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    bottom: -100px
  }
  .validation_popup_details {
    font-size: 16px;
    margin: 10px 0px 25px 0px;
    line-height: 1.5;
    color: $gray-darkest;
  }

  .validation_popup_actions {
    margin-top: 20px;
    .backToBsn {
      border: none !important;
      padding-left: 0px;
    }
  }
  .greyOut {
    color: $gray;
    background-color: $gray-light;
    border-color: $gray-light;
  }
  .patient-accountability .overlay > div {
    padding: 0px 25px 20px 25px !important;
  }
  .customStartDate {
    /deep/
    .form-group-simple input {
      padding-left: 35px !important;
      width: 95%;
    }
    /deep/
    .vdp-datepicker__calendar {
      position: relative !important;
      margin-bottom: 20px !important;
    }
  }
  .error {
    font-size: $form-group-details-font-size;
    padding-top: 10px;
    color: $red;
    transition: $form-group-error-transition;
    margin: 0px 0px 0px 25px;
  }

</style>
